<template>
    <div class="admin-site">
        <div class="content-container">
            <div class="header">
                <div class="title">Posts Pending Approval</div>
            </div>
            <div class="content">

                <div class="row">                    
                    <div class="categories-select content-container">
                        <div class="categories-header header">
                            <div class="title">
                                Categories
                                <button class="button-add" @click="addNewCategory">Add</button>
                            </div>
                        </div>
                        <div class="categories-list content">
                            <div  v-for="category in categories" :key="category.id"  :class="{'selected-category': category.id === selectedCategoryId}">
                                <span class="category" @click="selectCategory(category.id)">{{ category.sequence }} - {{category.name}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="category-editor" v-if="selectedCategory != null">
                        <AddEditCategory :category="selectedCategory" @deleteCategory="deleteCategory" @save="saveCategory"/>
                    </div>                    
                </div>

                <div class="row">                    
                    <div class="boards-select content-container">
                        <div class="boards-header header">
                            <div class="title">
                                Boards
                                <button class="button-add" @click="addNewBoard">Add</button>
                            </div>
                        </div>
                        <div class="boards-list content">
                            <div v-for="board in boards" :key="board.id" :class="{'selected-board': board.id === selectedBoardId}">
                                <span class="board" @click="selectBoard(board.id)">{{board.categorySequence}}.{{ board.displaySequence }} - {{board.name}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="boards-editor" v-if="selectedBoardId != null">
                        <AddEditBoard :board="selectedBoard" :categories="categories" @save="saveBoard" @deleteBoard="deleteBoard"/>
                    </div>                    
                </div>


            </div>
        </div>
    </div>
</template>


<script>
import api from "../../api/api";
import AddEditCategory from '../Admin/Category/AddEditCategory.vue';
import AddEditBoard from "../Admin/Boards/AddEditBoard.vue";
import dialogs from '../../modules/dialogs';

export default {
    components: {
        AddEditCategory,
        AddEditBoard,
    },
    data() {
        return {
            categories: [],
            selectedCategoryId: null,
            boards: [],
            selectedBoardId: null,
        };
    },
    computed: {
        selectedBoard() {
            if(this.selectedBoardId == null) {
                return null;
            }
            else if (this.selectedBoardId == -1) {
                return {
                    id: null,
                    name: null,
                    categoryId: null
                }
            }
            return this.boards.find(b => b.id == this.selectedBoardId);
        },
        selectedCategory() {
            if(this.selectedCategoryId == null) {
                return null;
            }
            else if(this.selectedCategoryId == -1) {
                return {
                    id: null,
                    name: null,
                };
            }
            return this.categories.find(c => c.id == this.selectedCategoryId);
        },
    },
    created() {
        this.initializeComponent();
    },
    methods: {
        selectBoard(boardId){
            this.selectedBoardId = boardId;
        },
        initializeComponent() {
            api.get('/boards/categories').then((r) => {                
                this.categories = r.data;                
            });
            api.get('/boards').then((r) => {
                if(r.data) {
                    let boards = [];
                    let sortedCategories = r.data.categories.sort((a, b) => {
                        return a.displaySequence < b.displaySequence;
                    })
                    for(let i = 0; i < sortedCategories.length; i++){
                        const cat = sortedCategories[i];
                        boards = boards.concat(cat.boards.map((b) => {
                            return {
                                ...b,
                                categoryId: cat.id,
                                categorySequence: cat.displaySequence
                            };
                        }));
                    }
                    this.boards = boards;
                }
            });
        },
        selectCategory(categoryId) {
            this.selectedCategoryId = categoryId;
        },
        addNewCategory() {
            this.selectedCategoryId = -1;
        },
        addNewBoard() {
            this.selectedBoardId = -1;
        },
        async deleteCategory(catId) {
            if(await dialogs.confirmAsync("Are you sure you want to delete this category?")) {
                api.delete('/boards/categories/' + catId, null).then(() => {
                    this.selectedCategoryId = null;
                    this.initializeComponent();
                });
            }
        },
        async deleteBoard(boardId) {
            if(await dialogs.confirmAsync("Are you sure you want to delete this board?")) {
                api.delete('/boards/' + boardId, null).then(() => {
                    this.selectedCategoryId = null;
                    this.selectedBoardId = null;
                    this.initializeComponent();
                });
            }
        },
        saveCategory(cat) {
            if(this.categories.some(c=>c.name == cat.name && c.id != cat.id)) {
                alert('Already a category with that name');
                return;
            }
            api.post('/boards/categories', {
                id: cat.id,
                name: cat.name,
                sequence: cat.sequence == null ? null : parseInt(cat.sequence)
            }).then(() => {
                this.selectedCategoryId = null;
                this.selectedBoardId = null;
                this.initializeComponent();
            })
        },
        saveBoard(board) {
            if(this.boards.some(b=>b.name == board.name && b.id != board.id)) {
                alert('Already a board with that name');
                return;
            }
            api.post('/boards', {
                id: board.id,
                name: board.name,
                status: board.statusId,
                categoryId: board.categoryId,
                displaySequence: board.displaySequence == null ? null : parseInt(board.displaySequence),
                typeID: board.typeID,
                description: board.description
            }).then(() => {
                this.selectedCategoryId = null;
                this.selectedBoardId = null;
                this.initializeComponent();
            })

        },
    }
}
</script>

